import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SHARED_IMPORTS } from 'src/app/utils/other/standalone-import';

@Component({
  selector: 'app-filter-create',
  templateUrl: './filter-create.component.html',
  styleUrls: ['./filter-create.component.scss'],
  standalone: true,
  imports: [SHARED_IMPORTS, ButtonModule]
})
export class FilterCreateComponent {
  filterName = '';

  @Output() saveFilterClicked = new EventEmitter<string>();

  onSubmit() {
    const newFilterName = this.filterName;
    this.filterName = '';
    if (newFilterName.length > 0) {
      this.saveFilterClicked.emit(newFilterName);
    }
  }
}
